import { NavLink, Outlet } from 'react-router-dom';
import { History, LogOut, Server } from 'lucide-react';
import { useAuth } from '../lib/auth';

function navClass({ isActive }: { isActive: boolean }) {
  return `inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-sm ${
    isActive ? 'bg-slate-800 text-white' : 'text-slate-400 hover:text-white'
  }`;
}

export function Layout() {
  const operator = useAuth((s) => s.operator);
  const logout = useAuth((s) => s.logout);
  return (
    <div className="min-h-screen">
      <header className="border-b border-slate-800 bg-slate-950/80 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3">
          <div className="text-base font-semibold">
            firmio<span className="text-violet-400">.</span>{' '}
            <span className="text-slate-400">console</span>
          </div>
          <nav className="flex gap-1">
            <NavLink to="/" end className={navClass}>
              <Server className="h-4 w-4" /> Clienți
            </NavLink>
            <NavLink to="/audit" className={navClass}>
              <History className="h-4 w-4" /> Jurnal
            </NavLink>
          </nav>
          <div className="ml-auto flex items-center gap-3 text-sm text-slate-400">
            <span className="hidden sm:inline">{operator?.name}</span>
            <button
              type="button"
              onClick={logout}
              className="inline-flex items-center gap-1 rounded-lg px-2 py-1 hover:bg-slate-800 hover:text-white"
            >
              <LogOut className="h-4 w-4" /> Ieșire
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
